// src/lib/queryClient.js
import { QueryClient } from '@tanstack/react-query';

/**
 * React Query Client Configuration
 * 
 * This configuration optimizes data fetching and caching for the Learn Astra XR platform.
 * 
 * Key settings:
 * - staleTime: How long data is considered fresh (5 minutes)
 * - cacheTime: How long unused data stays in cache (10 minutes)
 * - refetchOnWindowFocus: Automatically refetch when user returns to tab
 * - refetchOnReconnect: Refetch when network reconnects
 * - retry: Number of retry attempts for failed requests
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is fresh for 5 minutes
      staleTime: 5 * 60 * 1000,
      
      // Cache data for 10 minutes after last use
      cacheTime: 10 * 60 * 1000,
      
      // Refetch when user returns to window/tab
      refetchOnWindowFocus: true,
      
      // Refetch on network reconnection
      refetchOnReconnect: true,
      
      // Retry failed requests once
      retry: 1,
      
      // Don't refetch on mount if data is still fresh
      refetchOnMount: false,
      
      // Keep previous data while fetching new data (better UX)
      keepPreviousData: true,
    },
    mutations: {
      // Don't retry mutations by default (avoid duplicate actions)
      retry: 0,
    },
  },
});

export default queryClient;

